import React, { memo, PropsWithChildren, ReactNode, ReactElement, Fragment } from 'react';
import { useSettings } from '@core/utils/hooks/misc/useSettings';

export interface HasMultiCurrencyProps {
  singleCurrency?: ReactNode | ReactElement;
  children?: ReactNode | ReactElement;
}

export const HasMultiCurrency = memo((props: HasMultiCurrencyProps) => {
  const settings = useSettings();
  if (!settings) return <Fragment>{props.singleCurrency}</Fragment>;

  if (!settings.isMulticurrency) return <Fragment>{props.singleCurrency}</Fragment>;

  return <Fragment>{props.children}</Fragment>;
});
